<template>
    <div>
        <h2>Participations par genre</h2><br />
        <apexchart type=pie width=400 ref="pieGender" :options="options" :series="series" />
    </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

  export default {
    components: {
        apexcharts: VueApexCharts
    },      
    props: {
        chartDatas: { type: Object, required: false, default: function () { return {}}},
    },
    watch: {
        
 
    chartDatas : {
        // deep: true,
        handler(newValue) {   
           
           if(newValue.percent_female > 0) {
            var y = newValue.percent_female   
            var x =  newValue.percent_male
           } else {
            var y =0   
            var x =0
           }
            this.basechart(x, y) 
        }
    }}, 
    data: function () {
        return {
            enable : false,
            numb : [],
            options : {},
            series : []
        }
     },
     methods : {
        basechart(x, y) { 

            this.series = [x, y],
            this.options = {
                labels: ['Homme', 'Femme'],
                chart : {
                    width: 420,
                    events: {
                      click: function (event, chartContext, config) {
                      console.log( config)
                    }
                  }
                },
                legend: {
                    position: 'top'
                }
            }
        
            try {  
               this.$refs.pieGender.updateSeries(this.series, true);
               this.$refs.pieGender.updateOptions(this.options, false, true);
                
            } catch (err) {
               console.log(err)
            }
        }
     }
  }
</script>